import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { AbilityEffects } from './store/ability.effects';
import { AbilityNamespace, AbilityReducer } from './store/ability.store';
import { RoleEffects } from './store/role.effects';
import { RoleNamespace, RoleReducer } from './store/role.store';

@NgModule({
  imports: [
    StoreModule.forFeature(RoleNamespace, RoleReducer),
    StoreModule.forFeature(AbilityNamespace, AbilityReducer),
    EffectsModule.forFeature([RoleEffects, AbilityEffects]),
  ],
})
export class RolesDataModule {}
